import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Form, Field } from 'react-final-form';
import createSubmitListenerDecorator from 'final-form-submit-listener';
import arrayMutators from 'final-form-arrays';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { ProductInformation, ProductDetails } from '.';

import { Divider } from 'vqp-common';
import { Button } from '../../common';
import { ProductTimeRestrictions } from './ProductTimeRestrictions';

const Title = styled.div`
  padding: 20px 20px;
  color: ${(props) => props.theme.colors.textBold};
  font-size: 18px;
  font-weight: 700;
`;
const Footer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px 40px;
  justify-content: space-between;
`;

const ErrorText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.error};
`;

const ContentWrapper = styled.div`
  padding: 15px;
  height: calc(100vh - 300px);
  overflow-y: auto;
`;

const CustomTabList = styled(TabList)`
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGrey};
  margin: 0 0 10px;
  padding: 0;
  text-align: center;
`;

const CustomTab = styled(Tab)`
  display: inline-block;
  list-style: none;
  padding: 6px 0;
  width: 33%;
  cursor: pointer;
  color: ${(props) => props.theme.colors.textBold};
  font-size: 14px;

  &.react-tabs__tab--selected {
    border-radius: 0;
    border: 0;
    border-bottom: 3px solid ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
  }
`;

const getTabForField = (fieldName) => {
  switch (fieldName) {
    case 'details':
      return 1;
    case 'hasRestrictions':
    case 'restrictions':
      return 2;
    default:
      return 0;
  }
};

const tabsIds = [
  'product-information-wrapper',
  'product-details-wrapper',
  'product-time-restrictions-wrapper'
];

export const ProductModalContent = ({
  product,
  loading,
  category,
  onSubmitForm,
  orderDetails,
  setOrderDetails,
  storeId
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [error, setError] = useState('');

  const submitListener = useCallback(
    createSubmitListenerDecorator({
      beforeSubmit: (formApi) => {
        const fields = formApi.getRegisteredFields();
        const invalidField = fields.find((fieldName) => {
          const state = formApi.getFieldState(fieldName);
          if (state.error) {
            return true;
          }
          return false;
        });

        if (invalidField) {
          const tab = getTabForField(invalidField);
          console.log(tab);

          setTabIndex(tab);
          setError('Um ou mais campos estão inválidos!');

          const field = document.querySelector(`form [name="${invalidField}"]`);
          const tabWrapper = document.getElementById(tabsIds[tab]);

          if (field && tabWrapper) {
            const tabWrapperNewOffsetTop = field.getBoundingClientRect().top;
            tabWrapper.scrollTo(0, tabWrapperNewOffsetTop);
          }

          setTimeout(() => setError(''), 5000);
        } else {
          setError('');
        }
      }
    }),
    []
  );

  if (loading) {
    return <ContentWrapper></ContentWrapper>;
  }

  return (
    <Form
      onSubmit={onSubmitForm}
      subscription={{ submitting: true }}
      mutators={{
        ...arrayMutators
      }}
      decorators={[submitListener]}
      validateOnBlur={true}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Field
            name="category"
            initialValue={category}
          >
            {({ input, meta }) => {
              return (
                <input
                  type="hidden"
                  {...input}
                />
              );
            }}
          </Field>
          <Field
            name="id"
            initialValue={product && product.id}
          >
            {({ input, meta }) => {
              return (
                <input
                  type="hidden"
                  {...input}
                />
              );
            }}
          </Field>
          <Title>{product ? 'Editar produto' : 'Cadastrar produto'}</Title>
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            <CustomTabList>
              <CustomTab>Informações</CustomTab>
              <CustomTab>Complementos</CustomTab>
              <CustomTab>Restrição de Horários</CustomTab>
            </CustomTabList>
            <TabPanel forceRender={true}>
              <ContentWrapper id={`product-information-wrapper`}>
                <ProductInformation defaultProduct={product} />
              </ContentWrapper>
            </TabPanel>
            <TabPanel forceRender={true}>
              <ContentWrapper id={`product-details-wrapper`}>
                <ProductDetails
                  defaultDetails={product && product.details}
                  orderDetails={orderDetails}
                  setOrderDetails={setOrderDetails}
                  storeId={storeId}
                />
              </ContentWrapper>
            </TabPanel>
            <TabPanel forceRender={true}>
              <ContentWrapper id={`product-time-restrictions-wrapper`}>
                <ProductTimeRestrictions
                  defaultHasRestrictions={product && product.hasRestrictions}
                  defaultRestrictions={product && product.restrictions}
                />
              </ContentWrapper>
            </TabPanel>
          </Tabs>
          <Divider />
          <Footer>
            <ErrorText>{error}</ErrorText>
            <Button
              type={'submit'}
              className="primary"
            >
              {product ? 'Atualizar produto' : 'Cadastrar produto'}
            </Button>
          </Footer>
        </form>
      )}
    />
  );
};
